import { render } from "./IImportExport.vue?vue&type=template&id=39dc45c6&scoped=true&ts=true"
import script from "./IImportExport.vue?vue&type=script&lang=ts"
export * from "./IImportExport.vue?vue&type=script&lang=ts"

import "./IImportExport.vue?vue&type=style&index=0&id=39dc45c6&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/SuperLink-华为云生产环境/SuperLink-Manager-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39dc45c6"]])

export default __exports__